@if (
  {
    chipMessage: chipMessage$ | async,
    companySettings: companySettings$ | async,
    createDialogIsOpen: createDialogService.isOpen$ | async,
    currentMeeting: currentMeeting$ | async,
    currentPerson: currentPerson$ | async,
    currentUserId: currentUserId$ | async,
    disableNavLinks: disableNavLinks$ | async,
    enableSurveys: enableSurveys$ | async,
    isEditing: isEditing$ | async,
    isFetchingData: filterService.isFetchingData$ | async,
    isManageeOrAbove: isManageeOrAbove$ | async,
    isObserver: isObserver$ | async,
    language: language$ | async,
    mainToolbarHasShadow: mainToolbarHasShadow$ | async,
    meetingTeam: meetingService.team$ | async,
    pageTitle: pageTitle$ | async,
    participants: participants$ | async,
    toolBarHidden: mainToolbarHidden$ | async,
    currentConversationMeeting: currentConversationMeeting$ | async,
    segueEnhancements: segueEnhancements$ | async,
    autofollowFacilitator: autofollowFacilitator$ | async,
    toolbarBackButton: toolbarBackButton$ | async,
    webGlobalSearchEnabled: webGlobalSearchEnabled$ | async,
  } | ngrxPush;
  as data
) {
  @if (data.currentPerson && !data.toolBarHidden) {
    <div class="terrafy-top-toolbar" [class.terrafy-top-toolbar--with-back]="!!data.toolbarBackButton">
      @if (data.toolbarBackButton; as backButton) {
        <button
          type="button"
          class="terrafy-top-toolbar__back-link"
          data-cy="top-toolbar_back-link"
          (click)="onBackButtonClick(backButton.source)">
          <terra-icon icon="arrow-left" size="16" />{{ backButton.label }}
        </button>
      }
      <header class="terrafy-top-toolbar__header" [class.has-box-shadow]="data.mainToolbarHasShadow !== false">
        <!-- Mobile Navigation Menu Trigger -->
        @if (!(meetingStarted || data.isEditing)) {
          <button
            data-cy="top-toolbar_hamburger-menu-button"
            class="menu-button-hamburger"
            mat-icon-button
            (click)="openMenu()"
            aria-label="Open navigation menu">
            <terra-icon icon="list" />
          </button>
        }

        <div class="terrafy-top-toolbar__title-container">
          <h1
            attr.data-cy-dynamic="top-toolbar_page-title__{{ data.pageTitle }}"
            data-cy="top-toolbar_page-title"
            class="page-title terrafy-top-toolbar__title hide-lt-sm"
            [class.no-border-left]="meetingStarted">
            <span [innerHTML]="data.pageTitle | terraHtmlSanitizer"></span>
            @if (data.meetingTeam; as team) {
              <span>- {{ team?.name }}</span>
            }
          </h1>
          <p class="terrafy-top-toolbar__description hide-lt-sm">{{ data.pageTitle | pageDescription | ngrxPush }}</p>
        </div>
        @if (data.chipMessage; as message) {
          <mat-chip-listbox
            data-cy="top-toolbar_chip-message"
            class="hide-lt-sm"
            matTooltip="Shared Configurations and companies that have prevented their coach control are Read Only."
            matTooltipClass="ninety-tooltip">
            <mat-chip-option selected color="accent" class="ninety-chip">{{ message }}</mat-chip-option>
          </mat-chip-listbox>
        }
        <div class="fill-remaining-space"></div>
        <ng-template #askMazButton>
          <maz-ask-button />
        </ng-template>
        @if (data.currentMeeting) {
          <div class="ask-maz-meeting-wrapper">
            <ng-container *ngTemplateOutlet="askMazButton" />
          </div>
          <div class="presence-container">
            <ninety-notetaker-control />
            <!-- Flag off: show all participants via presence -->
            @if (!data.segueEnhancements && data.participants?.userIds?.length > 0) {
              @for (userId of data.participants.userIds; track userId) {
                <div class="avatar-container" [class.presenter]="userId === data.currentMeeting.presenterUserId">
                  @if (store.select(selectUserAvatarInfo(userId)) | ngrxPush; as avatar) {
                    <terra-avatar
                      class="meeting-user"
                      [initials]="avatar.userInitials"
                      [src]="avatar.pictureURL"
                      [ninetyContactCardHover]="userId"
                      orientation="below" />
                  }
                  @if (userId === data.currentMeeting.presenterUserId) {
                    <terra-badge icon="microphone" color="brand" size="small" class="presenter-icon" />
                  }
                </div>
              }
              @if (data.participants?.usernames?.length > 0) {
                <div
                  [matTooltip]="data.participants.usernames.join(' \n ')"
                  matTooltipClass="ninety-tooltip multiline-tooltip"
                  matTooltipPosition="above"
                  ninetyStopPropagation
                  class="d-print-none more-participants">
                  <span class="user-initials"> + {{ data.participants.usernames.length }} </span>
                </div>
              }
            }
            <!-- FF on: show presenter only. Dropped once autofollow marks them in the meeting sidenav. -->
            @if (data.segueEnhancements && !data.autofollowFacilitator && data.currentMeeting.presenterUserId) {
              <div class="avatar-container presenter">
                @if (store.select(selectUserAvatarInfo(data.currentMeeting.presenterUserId)) | ngrxPush; as avatar) {
                  <terra-avatar
                    class="meeting-user"
                    [initials]="avatar.userInitials"
                    [src]="avatar.pictureURL"
                    [ninetyContactCardHover]="data.currentMeeting.presenterUserId"
                    orientation="below" />
                }
                <terra-badge icon="microphone" color="brand" size="small" class="presenter-icon" />
              </div>
            }
            @if (data.currentUserId !== data.currentMeeting.presenterUserId && data.isManageeOrAbove) {
              <ninety-button class="claim-presenter-button" stroked (click)="openChangePresenterDialog()">
                <terra-icon icon="microphone" aria-hidden="true" /> Claim Presenter
              </ninety-button>
            }
          </div>
        }
        @if (data.currentConversationMeeting) {
          @if (data.currentConversationMeeting.occupants?.length > 0) {
            <div class="presence-container">
              @for (userId of data.currentConversationMeeting.occupants; track userId) {
                @if (store.select(selectUserAvatarInfo(userId)) | ngrxPush; as avatar) {
                  <terra-avatar class="meeting-user" [initials]="avatar.userInitials" [src]="avatar.pictureURL" />
                }
              }
            </div>
          }
        }
        <div class="toolbar-actions-right">
          @if (!data.currentMeeting) {
            <ng-container *ngTemplateOutlet="askMazButton" />
          }
          @if (data.webGlobalSearchEnabled) {
            <ninety-global-search-input />
          }
          <ninety-notification-feed-trigger />
          <ninety-inbox-trigger />
          @if (data.isManageeOrAbove) {
            <ninety-universal-create-btn
              [disabled]="
                data.disableNavLinks ||
                data.isFetchingData ||
                data.isObserver ||
                !(userTeams$ | async)?.length ||
                !!data.createDialogIsOpen
              "
              [locked]="!(universalCreateFeature$ | ngrxPush)"
              (openUniversalCreateModal)="openUniversalCreateModal()" />
          }
        </div>
      </header>
    </div>
  }
}
